module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "transition": "fade-transition",
      "width": "1300px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "card-title-background"
  }, [_vm._v("\n      View Stats Analysis\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "overflow": "hidden",
      "margin-top": "10px",
      "min-height": "35px"
    }
  }, [_c('div', [_c('stats-data-table', {
    attrs: {
      "isView": "true",
      "viewHandle": _vm.handle
    }
  })], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fc3ec28"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/StatisticsAnalysis/ViewModalDialog.vue
// module id = 2184
// module chunks = 0